module.exports = __webpack_public_path__ + "img/6.ea46c888.png";